import React from 'react';

// Hooks
import { useNavigate } from 'react-router-dom';

// Icons
import { NoTemplateCIcon } from '~/assets/images';
import OlcButton from '~/components/General/OlcButton';
import EmptyStateCard from '~/components/General/EmptyStateCard';

import { MESSAGES } from '~/utils/message';

const NoTemplateScreen = () => {
  const navigate = useNavigate();
  return (
    <>
      <div className="olcEmptyStateToolbar">
        <OlcButton variant="secondary" onClick={() => navigate('/hire-a-designer')}>
          {MESSAGES.TEMPLATE.NO_TEMPLATE_HIRE_DESIGNER_BUTTON}
        </OlcButton>
        <OlcButton variant="primary" onClick={() => navigate('/create-template')}>
          {MESSAGES.TEMPLATE.NO_TEMPLATE_BUTTON}
        </OlcButton>
      </div>
      <EmptyStateCard
        icon={NoTemplateCIcon}
        iconAlt="no-templates"
        title={MESSAGES.TEMPLATE.NO_TEMPLATE_TITLE}
        description={MESSAGES.TEMPLATE.NO_TEMPLATE_MESSAGE}
      />
    </>
  );
};

export default NoTemplateScreen;
